import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=077edc6e&scoped=true&"
import script from "./Regist.vue?vue&type=script&lang=js&"
export * from "./Regist.vue?vue&type=script&lang=js&"
import style0 from "./../assets/css/LoginRegist.css?vue&type=style&index=0&id=077edc6e&lang=css&scoped=true&"
import style1 from "./Regist.vue?vue&type=style&index=1&id=077edc6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077edc6e",
  null
  
)

export default component.exports